import { render } from "./DialogCompletaManutenzione.vue?vue&type=template&id=197f6035&scoped=true"
import script from "./DialogCompletaManutenzione.vue?vue&type=script&lang=js"
export * from "./DialogCompletaManutenzione.vue?vue&type=script&lang=js"

import "./DialogCompletaManutenzione.vue?vue&type=style&index=0&id=197f6035&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-197f6035"]])

export default __exports__